export const CRED_SECRET_KEY = "APPWRK-USMAN";